import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { success, vector } from "../../assets/img";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import { Margin, usePDF } from 'react-to-pdf';
import moment from "moment";
import DownloadCostPdf from "../../Component/DownloadCostPdf";
import { Toast } from "../../Component/Toast";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import CustomScroll from "../../Component/CustomScroll";
import { MaskIcon } from "../../Component/MaskIcon";
import { PRIMARY_COLOR, PRIMARY_COLOR_RGB } from "../../Services/Colors";

const Cost = () => {
  const location = useLocation();



  const listData = location.state?.listData;
  const slotId = location.state?.slotId;
  const lot_name = location.state?.lot_name;
  const time = location.state?.time;
  const date = location.state?.date;

  const { toPDF, targetRef } = usePDF({
    filename: `${`Garudacostreport_${date}_${time}`}.pdf`,
    page: { margin: Margin.MEDIUM, orientation: 'portrait' },
  });

  const [list, setList] = useState([]);
  const [downSuccess, setDownSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const tableRows = listData?.data?.rows ?? list?.data?.rows ?? [];
  const footerData = listData?.data?.totals ?? list?.data?.totals ?? [];

  const fetchList = async () => {
    try {
      const res = await get(`${URLS.SALESREPORT}/game/overall-cost?game_slot_id=${slotId}`);
      //       console.log("Fetched data:", res);
      setList(res);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("pageReloaded", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  useEffect(() => {
    const wasReloaded = sessionStorage.getItem("pageReloaded");

    if (wasReloaded === "true") {
      fetchList();
      sessionStorage.removeItem("pageReloaded"); // important
    }
  }, []);


  const generatePdf = ({
    title = "Cost-Wise Report",
    date,
    lot_name,
    time,
    tableRows = [],
    footerData = [],
  }) => {
    // const doc = new jsPDF("p", "mm", "a4");
    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: [180, 180], // custom taller page
    });


    const pageWidth = doc.internal.pageSize.getWidth();
    let currentY = 15;

    /* =======================
       HEADER
    ======================= */

    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.text(`Garuda Agency – ${title}`, pageWidth / 2, currentY, {
      align: "center",
    });

    currentY += 7;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(
      `Date: ${moment(date).format("DD-MM-YYYY")}  |  Lot: ${lot_name}  |  Time: ${time}`,
      pageWidth / 2,
      currentY,
      { align: "center" }
    );

    currentY += 6;

    doc.text(
      `Report Generated on: ${moment().format("DD-MM-YYYY hh:mm a")}`,
      pageWidth / 2,
      currentY,
      { align: "center" }
    );

    currentY += 4;

    doc.setLineWidth(0.4);
    doc.line(10, currentY, pageWidth - 10, currentY);

    currentY += 6;

    /* =======================
       TABLE (UPDATED)
    ======================= */

    autoTable(doc, {
      startY: currentY,

      head: [[
        "Details",
        "Sales Qty",
        "Draw Qty",
        "Sale Cost",
        "Draw Cost",
        "P & L",
      ]],

      body: tableRows.map((row) => ([
        row.details ?? "",
        row.sales_qty ?? 0,
        row.draw_qty ?? 0,
        row.sale_cost ?? 0,
        row.draw_cost ?? 0,
        row.p_l ?? 0,
      ])),

      foot: footerData.map((item, index) => {
        const isLast = index === footerData.length - 1;
        const fillColor = isLast ? [198, 239, 206] : [246, 220, 181];
        const textColor = isLast ? 0 : 0;
        return [
          {
            content: item.details ?? "",
            colSpan: 3,
            styles: { fontStyle: "bold", fillColor, textColor },
          },
          {
            content: item.sale_cost ?? 0,
            styles: { fillColor, textColor },
          },
          {
            content: item.draw_cost ?? 0,
            styles: { fillColor, textColor },
          },
          {
            content: item.p_l ?? 0,
            styles: { fillColor, textColor },
          },
        ];
      }),
      showFoot: "lastPage",
      styles: {
        cellPadding: 1,
        overflow: "linebreak",
        lineWidth: 0.1,
        lineColor: PRIMARY_COLOR_RGB,
        valign: "middle",
        fontStyle: "bold",
        textColor: 'black',
        fontSize: 10,
      },

      headStyles: {
          fillColor: PRIMARY_COLOR_RGB,
           textColor: [255, 255, 255],
        fontStyle: "bold",
        valign: "middle",
        halign: "center",
        lineWidth: 0.3,
        fontSize: 11,
      },

      columnStyles: {
        0: { cellWidth: 55 }, // Details column wider
      },

      margin: { left: 8, right: 8 },
    });

    /* =======================
       SAVE
    ======================= */

    doc.save(
      `Garudacostreport_${moment(date).format("DD-MM-YYYY")}_${time}.pdf`
    );
  };


  const handleDownload = async () => {
    if (!tableRows?.length) {
      Toast("No data available to download");
      return;
    }

    try {
      setLoading(true);
      generatePdf({
        title: "Cost Report",
        date: date,
        time: time,
        lot_name: lot_name,
        tableRows: tableRows,
        footerData: footerData
      });
      setDownSuccess(true);
    } catch (error) {
      console.error(error);
      Toast("Failed to download PDF");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="dashRightView  d-flex ac-jb flex-column">
      <CustomScroll height="100vh">
        <div className="container_overalls">

          {/* DOWNLOAD ICON */}
          <div
            className="d-flex ac-je"

            style={{ cursor: "pointer", marginRight: 22, marginBottom: 22 }}
          >
            {loading ? (
              <span
                className="spinner-border spinner-border-sm"
                style={{ color: PRIMARY_COLOR, width: 12, height: 12 }}
              />
            ) : downSuccess ? (
              <img src={success} height={20} />
            ) : (
              <MaskIcon onClick={handleDownload} src={vector} height={15} />
            )}
          </div>

          {/* TABLE */}
          <div className="tablealign hide-horizontal-scroll" style={{ overflowX: "auto", marginTop: 16, width: '100%' }}>
            <table
              style={{
                width: "100%",
                minWidth: "600px",
                borderCollapse: "collapse",
                marginBottom: tableRows.length === 0 ? 0 : 70,
              }}
            >
              {/* HEADER */}
              <thead>
                <tr>
                  {[
                    "Date",
                    "Time",
                    "Lot",
                    "Details",
                    "Sales Qty",
                    "Draw Qty",
                    "Sale Cost",
                    "Draw Cost",
                    "P & L",
                  ].map((head, i) => (
                    <th
                      className="primary1"
                      key={i}
                      style={{
                        textAlign: "center",
                        border: "1px solid #c6c6c6",
                        padding: "5px",
                        fontSize: 15,
                        fontFamily: 'f3'
                      }}
                    >
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>

              {/* BODY */}
              <tbody>
                {tableRows.map((row, index) => (
                  <tr key={index}>
                    <td style={{ fontSize: 12, fontFamily: 'f2', paddingLeft: 3, border: "1px solid #c6c6c6", minWidth: 95 }}>{row.date ?? ""}</td>
                    <td style={{ fontSize: 12, fontFamily: 'f2', paddingLeft: 3, border: "1px solid #c6c6c6" }}>{row.time ?? ""}</td>
                    <td style={{ fontSize: 12, fontFamily: 'f2', paddingLeft: 3, border: "1px solid #c6c6c6" }}>{row.lot ?? ""}</td>
                    <td style={{ fontSize: 12, fontFamily: 'f2', paddingLeft: 3, border: "1px solid #c6c6c6", minWidth: 180 }}>{row.details ?? ""}</td>
                    <td style={{ fontSize: 12, fontFamily: 'f2', paddingLeft: 3, border: "1px solid #c6c6c6" }}>{row.sales_qty ?? 0}</td>
                    <td style={{ fontSize: 12, fontFamily: 'f2', paddingLeft: 3, border: "1px solid #c6c6c6" }}>{row.draw_qty ?? 0}</td>
                    <td style={{ fontSize: 12, fontFamily: 'f2', paddingLeft: 3, border: "1px solid #c6c6c6" }}>{row.sale_cost ?? 0}</td>
                    <td style={{ fontSize: 12, fontFamily: 'f2', paddingLeft: 3, border: "1px solid #c6c6c6" }}>{row.draw_cost ?? 0}</td>
                    <td
                      style={{ fontSize: 12, fontFamily: 'f2', paddingLeft: 3, border: "1px solid #c6c6c6" }}
                      className={row.p_l < 0 ? "loss" : "profit"}
                    >
                      {row.p_l ?? 0}
                    </td>
                  </tr>
                ))}
              </tbody>

              {/* FOOTER */}
              <tfoot style={{ borderRight: `2px solid ${PRIMARY_COLOR}` }}>
                {footerData.map((item, index) => {
                  const isLast = index === footerData.length - 1;

                  return (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: isLast ? PRIMARY_COLOR : '#5c8dadcc', // ✅ DARK GREEN FOR LAST
                        fontWeight: isLast ? "bold" : "normal",
                        color: "white", // optional but recommended
                      }}
                    >
                      {/* LEFT EMPTY BLOCK */}
                      <td
                        colSpan={3}
                        style={{
                          fontSize: 12,
                          fontFamily: 'f2',
                          borderTop: `2px solid ${PRIMARY_COLOR}`,
                          borderBottom: `2px solid ${PRIMARY_COLOR}`,
                          borderLeft: `2px solid ${PRIMARY_COLOR}`,
                          borderRight: "none",
                          color: 'white'
                        }}
                      ></td>

                      {/* DETAILS */}
                      <td
                        colSpan={3}
                        style={{
                          fontSize: 12,
                          fontFamily: 'f2',
                          borderTop: `2px solid ${PRIMARY_COLOR}`,
                          borderBottom: `2px solid ${PRIMARY_COLOR}`,
                          borderLeft: "2px solid transparent",
                          borderRight: "2px solid transparent",
                          paddingRight: 5,
                          color: 'white',
                          textAlign: 'right'
                        }}
                      >
                        {item.details ?? ""}
                      </td>

                      {/* MIDDLE EMPTY BLOCK */}
                      {/* <td
                      colSpan={0}
                      style={{
                        fontSize: 12,
                        fontFamily: 'f2',
                        borderTop: `2px solid ${PRIMARY_COLOR}`,
                        borderBottom: `2px solid ${PRIMARY_COLOR}`,
                        borderLeft: "2px solid transparent",
                        borderRight: "none",
                      }}
                    ></td> */}

                      {/* SALE COST */}
                      <td
                        style={{
                          fontSize: 12,
                          fontFamily: 'f2',
                          borderTop: `2px solid ${PRIMARY_COLOR}`,
                          borderBottom: `2px solid ${PRIMARY_COLOR}`,
                          borderLeft: "none",
                          borderRight: "none",
                          paddingLeft: 3,
                          color: 'white'
                        }}
                      >
                        {item.sale_cost ?? 0}
                      </td>

                      {/* DRAW COST */}
                      <td
                        style={{
                          fontSize: 12,
                          fontFamily: 'f2',
                          borderTop: `2px solid ${PRIMARY_COLOR}`,
                          borderBottom: `2px solid ${PRIMARY_COLOR}`,
                          borderLeft: "none",
                          borderRight: "none",
                          paddingLeft: 3,
                          color: 'white'
                        }}
                      >
                        {item.draw_cost ?? 0}
                      </td>

                      {/* RIGHT BORDER */}
                      <td
                        style={{
                          fontSize: 12,
                          fontFamily: 'f2',
                          borderTop: `2px solid ${PRIMARY_COLOR}`,
                          borderBottom: `2px solid ${PRIMARY_COLOR}`,
                          borderRight: `2px solid ${PRIMARY_COLOR}`,
                          borderLeft: "none",
                          paddingLeft: 3,
                          color: 'white'
                        }}
                        className={item.p_l < 0 ? "loss-text" : "profit-text"}
                      >
                        {item.p_l ?? 0}
                      </td>
                    </tr>
                  );
                })}
              </tfoot>

            </table>
            {tableRows.length === 0 ? (
              <div style={{
                width: '100%', display: 'flex',
                justifyContent: 'center'
              }}>
                <span style={{ fontSize: 15, fontFamily: 'f3' }}>No Data</span>
              </div>
            ) : null}
          </div>
          <div ref={targetRef} style={{
            position: "absolute",
            top: "-9999px",
            left: "-9999px",
            visibility: "visible",
          }}>
            <DownloadCostPdf
              title="Cost Report"
              generatedAt={moment(new Date()).format("DD-MM-YYYY hh:mm a")}
              slot={{ date: date, lot_name: lot_name, time: time || "N/A" }}
              tableRows={tableRows}
              footerData={footerData}
              totalColSpan={6}
            />
          </div>
        </div>
      </CustomScroll>
    </div>
  );
};

export default Cost;
